import script from "./CommonWageDetailBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonWageDetailBoard.vue?vue&type=script&setup=true&lang=ts"

import "./CommonWageDetailBoard.vue?vue&type=style&index=0&id=509a0412&lang=scss"

const __exports__ = script;

export default __exports__